import "./career.css";
import Image from "assets/png/careerpath.png";

const Career = () => {
  return (
    <div id="career">
      <div className="career">
        <div className="career-path">
          <div className="career-text">
            <p className="header black pry-text">
              Looking for a Job?{" "}
              <span className="purple">Secure Your Future with Us!</span>
            </p>

            <div className="career-position">
              <a
                href="https://noblecustomercare.pshanerp.com/CV.aspx"
                target="_blank"
                rel="noreferrer"
                className="bg-blue-100 px-16 py-4 rounded-xl text-white cursor-pointer"
              >
                Apply now
              </a>
            </div>
          </div>

          <img src={Image} alt="" className="career-image" />
        </div>
      </div>
    </div>
  );
};

export default Career;
